export default __webpack_public_path__ + "static/media/2B_360_3.06c13115.jpg";